module.exports = __webpack_public_path__ + "img/fish_bigclam.d40cecbf.png";